import { StoreonModule } from 'storeon'
import { toast } from 'react-toastify'
import { api } from '@/api'
import { defaultFiltersValue } from '@/apps/Tasks/const'
import { Events, State } from '../../interfaces'

export const taskModule: StoreonModule<State, Events> = (store) => {
  store.on('@init', () => ({
    tasks: {
      count: 0,
      next: null,
      previous: null,
      results: []
    },
    tasksCount: 0,
    statusLoadTasks: false,
    taskInfo: {
      page: 1,
      limit: 10,
      state: defaultFiltersValue.state
    }
  }))

  store.on('tasks/get', async (state) => {
    try {
      store.dispatch('statusLoadTasks/set', true)
      const data = await api.task.getTasks({ ...state.taskInfo })
      store.dispatch('tasks/save', data)
      store.dispatch('statusLoadTasks/set', false)
    } catch (e) {
      toast.error('Ошибка получения задач!')
      store.dispatch('statusLoadTasks/set', false)
    }
  })
  
  store.on('tasks/save', (state, event) => {
    return {
      tasks: event
    }
  })

  store.on('changeCheckedTasks/set', ({ tasks }, event) => {
    return {
      tasks: {
        ...tasks,
        results: tasks.results.map((task) => {
          if (task.id === event) {
            return {
              ...task,
              checked: !task.checked
            }
          }
          if (event === 'all') {
            return {
              ...task,
              checked: true
            }
          }
          if (event === 'takeOf') {
            return {
              ...task,
              checked: false
            }
          }
          return task
        })
      }
    }
  })

  store.on('taskInfo/set', (state, event) => {
    return { taskInfo: { ...state.taskInfo, ...event } }
  })

  store.on('taskInfo/getCount', async () => {
    const { tasks_count } = await api.task.getTasksCount()

    store.dispatch('tasksCount/set', tasks_count)
  })

  store.on('taskInfo/clear', () => {
    return {
      taskInfo: {
        page: 1,
        user: undefined,
        limit: 10
      }
    }
  })

  store.on('tasks/clear', () => {
    return { tasks: { count: 0, next: null, previous: null, results: [] } }
  })

  store.on('statusLoadTasks/set', (state, event) => {
    return { statusLoadTasks: event }
  })

  store.on('tasksCount/set', (state, event) => {
    return { tasksCount: event }
  })
}
